import axios from 'axios'

axios.defaults.baseURL = process.env.VUE_APP_BASEURI
axios.defaults.headers.common['Authorization'] = localStorage.getItem('token') || undefined